import { AccountInfoData, UpdateAccountInfo } from 'types';
import { fetchAuthAccountInfoForWorkingFarm } from './auth';
import { getStoredFarmContext } from 'farmContext';
import { service } from '.';
import { cookies } from 'static';

const readStoredAuth = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  if (!stored) {
    return null;
  }
  try {
    return JSON.parse(stored) as { token?: string; username?: string };
  } catch {
    return null;
  }
};

const getToken = () => readStoredAuth()?.token;

export const getLoggedInUsername = () => readStoredAuth()?.username;

export const accountInfoQueryKey = () =>
  ['getAccountInfo', getLoggedInUsername() ?? '', getStoredFarmContext().farmId ?? ''] as const;

export const getAccountInfo = (): Promise<AccountInfoData> => {
  const { farmId } = getStoredFarmContext();
  return fetchAuthAccountInfoForWorkingFarm(getToken(), farmId);
};

export const updateAccountInfo = (params: UpdateAccountInfo) => service('/api/v1/accounts/edit', { method: 'PUT', data: params });

export const selfRegister = (params: { email: string, password: string }) => service('/api/v1/accounts/self-register', { method: 'POST', data: params });

export const setAccountFarm = (farmId: string | number) =>
  service('/api/v1/accounts/set-farm', { method: 'POST', params: { farmId } }, getToken());

export const selfDisableLspAccess = () => service('/api/v1/accounts/self-disable-lsp', { method: 'POST' }, getToken());

export const selfDisableBoardAccess = () => service('/api/v1/accounts/self-disable-board', { method: 'POST' }, getToken());

export const selfDisableCropsAccess = () => service('/api/v1/accounts/self-disable-crops', { method: 'POST' }, getToken());

export const selfEnableLspAccess = () => service('/api/v1/accounts/self-enable-lsp', { method: 'POST' }, getToken());

export const selfEnableBoardAccess = () => service('/api/v1/accounts/self-enable-board', { method: 'POST' }, getToken());

export const selfEnableCropsAccess = () => service('/api/v1/accounts/self-enable-crops', { method: 'POST' }, getToken());

export const selfStartTrial = (app: 'livestock' | 'crops' | 'bulletinBoard', farmId?: string | number) => {
  const params: { app: string; farmId?: string | number } = { app };
  if (farmId != null && String(farmId).trim() !== '') {
    params.farmId = farmId;
  }
  return service('/api/v1/accounts/self-start-trial', { method: 'POST', params }, getToken());
};
